import InfoAlertListItem from "./infoAlertListItem";
export default InfoAlertListItem;
